import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface AlbSubtype extends BaseEntity {
  kind: string;
  name: string;
  imagePath: string | null;
  thumbnailPath?: string | null;
  imageWidth?: number | null;
  imageHeight?: number | null;
  sortOrder?: number;
}

const albSubtypeApi = createCrudApi<AlbSubtype, never, never>('alb-subtype');

export const reorderAlbSubtypes = (vestmentId: number, ids: number[]) =>
  albSubtypeApi.reorder(ids, { vestment: vestmentId });

export async function updateAlbSubtype(
  id: number,
  image?: File
): Promise<AlbSubtype> {
  const formData = new FormData();
  if (image) {
    formData.append('image', image);
  }
  const response = await axiosInstance.post(`/alb-subtype/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}
